import styled from "styled-components";
import { colors } from "../../assets";
import { MainButtonContainer } from "../main-button/main-button-style";
import { InputBoxContainer } from "../input-box/input-box-style";

export const ErrorModalContainer = styled.div`
  display: none;
  color: ${colors["PR-001-100"]};
  position: fixed;
  z-index: 9999;
  background: ${colors["background-modal"]};
  left: 0;
  width: 100%;
  top: 0;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: "museo sans";

  &.active {
    display: flex;
  }

  &.error {
    color: ${colors["ER-001-100"]};

    .recover-modal-icon-bg {
      background: rgba(255, 65, 0, 0.3);
    }

    ${MainButtonContainer} {
      background: ${colors["ER-001-100"]};
    }
  }

  &.warning {
    .recover-modal-icon-bg {
      background: rgba(255, 240, 201, 0.3);
    }
  }

  .recover-modal {
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    padding: 20px 40px 40px;
    max-width: 620px;
  }

  .recover-modal-close {
    text-align: right;

    img {
      max-width: 18px;
      cursor: pointer;
    }
  }

  .recover-modal-main-title {
    display: flex;
    align-items: center;
    margin-bottom: 28px;
  }

  .recover-modal-icon {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .recover-modal-icon-bg {
    display: inline-block;
    background: rgba(179, 202, 220, 0.3);
    width: 62px;
    min-width: 62px;
    height: 62px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 20px;
    }
  }

  .recover-modal-main-action {
    padding-left: 80px;
  }

  .recover-modal-main {
    padding-right: 65px;
  }

  .recover-modal-main-copy {
    margin-bottom: 20px;
    color: ${colors["TX-001-50"]}};
  }

  .recover-modal-text {
    padding-left: 20px;
  }

  .recover-modal-button {
    display: flex;

    ${MainButtonContainer} {
      width: 160px;

      &:first-child {
        margin-right: 12px;
      }
    }
  }

  ${InputBoxContainer} {
    &.disabled {
      .input-box-main-field {
        &.required {
          &:before {
            top: 21px;
          }
        }

        input {
          color: ${colors["TX-001-30"]};
          border: none;
          &::placeholder {
            color: ${colors["TX-001-30"]};
          }
        }
      }
    }

    .input-box-main-field {
      input {
        border: 1px solid ${colors["PR-001-100"]};
        border-radius: 3px;
        padding: 9px 20px;
      }
    }
  }

  .export-error{
    display: none;
    color: red;
    &.active{
      display: flex;
    }
  }

  .server-error{
    color: red;
    margin-bottom: 40px;
    font-size: 1.2vw;
  }

  .button-error{
    width: 30%;
    position: relative;
    left: 50%;
    margin-left: -15%;
  }
`;
